/* eslint-disable prettier/prettier */
import requests from './httpServices'

class Withdraw {
  withdrawHistory(headers) {
    return requests.get('/secure/withdrawals', headers)
  }
  withdrawCreate(body, headers) {
    return requests.post('/secure/withdraw', body, headers)
  }
}

export default new Withdraw()
